import React, { Component } from 'react';

class EditEventos extends Component {
    state = {  }
    render() { 
        return (
            <div>Editar Eventos</div>
        );
    }
}
 
export default EditEventos;


// WEBPACK FOOTER //
// ./src/views/WebMaster/EditEventos.jsx